'use strict';

var $ = window.jQuery;

function init() {
	var $megaMenu = $(".nav.desktop .hasChild");
	if (!$megaMenu.length)
		return;

	var itemOverClass = "hovered";
	var minWidth = 760;

	function hoverStart() {
		if (window.innerWidth < minWidth)
			return;

		var $menuItem = $(this);
		$menuItem.siblings().removeClass(itemOverClass);
		$menuItem.addClass(itemOverClass);
	}

	function hoverEnd() {
		if (window.innerWidth < minWidth)
			return;

		var $menuItem = $(this);
		$menuItem.removeClass(itemOverClass);
	}

	$megaMenu.hoverIntent({
		over: hoverStart,
		out: hoverEnd,
		timeout: 200
	});
}

module.exports = {
	init: init
};
